import { set } from "dot-prop-immutable";

const ERROR_LOG_RECEIVED = "ERROR_LOG_RECEIVED";
const ERROR_LOG_RESET = "ERROR_LOG_RESET";
const ERROR_LOG_CHANGE_SELECTED = "ERROR_LOG_CHANGE_SELECTED";

export const changeSelectedError = value => ({
	type: ERROR_LOG_CHANGE_SELECTED,
	value
});

export const receivedErrorLog = value => ({
	type: ERROR_LOG_RECEIVED,
	value
});

const initial_state = {
	log: [],
	selected: null
};

export const errorLogReducer = (state = initial_state, action) => {
	switch (action.type) {
	case ERROR_LOG_RECEIVED:
		/*
		 * im prinzip verketten wir zwei set-aurufe damit die selection
		 * genullt wird wenn neue daten kommen.
		 */
		return set(
			set(state, "log", action.value),
			"selected", null
		);
	case ERROR_LOG_RESET:
		return state;
	case ERROR_LOG_CHANGE_SELECTED:
		return set(state, "selected", action.value);
	default:
		return state;
	}
};
